import React, { useState } from 'react';
import t from '@guestyci/localize/t.macro';
import { Text, Heading, Stack } from '@guestyci/arc';
import { MessageSquareText } from '@guestyci/icons/system';
import { PhoneInput } from '../PhoneInput';
import { getCountryByIso, getCallingCodeForCountry, DEFAULT_COUNTRY_ISO } from '../PhoneInput/countryData';
import { StepActions } from '../../layout';

const PhoneEntryStep = ({
  onSendCode,
  onPickDifferentMethod,
  error,
  isSubmitting,
}) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [countryCode, setCountryCode] = useState(DEFAULT_COUNTRY_ISO);

  const handleSendCode = () => {
    if (!phoneNumber.trim()) return;
    const country = getCountryByIso(countryCode);
    const dialCode = country?.dialCode || getCallingCodeForCountry(countryCode);
    onSendCode(countryCode, phoneNumber.trim(), dialCode);
  };

  return (
    <Stack spacing={6} justify="between" className="gst-w-full gst-flex-1">
      <Stack spacing={6}>
        <Stack align="center" justify="center" className="gst-rounded-full gst-bg-success-foreground gst-w-20 gst-h-20 gst-shrink-0">
          <MessageSquareText className="gst-size-6 gst-text-primary" aria-hidden="true" />
        </Stack>

        <Stack spacing={3}>
          <Heading variant="h2" className="gst-tracking-tight">
            {t('Set up SMS authentication')}
          </Heading>
          <Text type="secondary">
            {t("We'll use the phone number you enter below to send you a verification code via SMS.")}
          </Text>
        </Stack>

        <Stack spacing={4}>
          <Stack spacing={1}>
            <Text weight="medium" size="sm">{t('Phone number')}</Text>
            <PhoneInput
              value={phoneNumber}
              onChange={setPhoneNumber}
              countryCode={countryCode}
              onCountryChange={setCountryCode}
              disabled={isSubmitting}
            />
          </Stack>

          {error && (
            <Text type="error" size="sm">
              {error}
            </Text>
          )}
        </Stack>
      </Stack>

      <StepActions
        primaryLabel={t('Send code')}
        onPrimaryClick={handleSendCode}
        primaryDisabled={!phoneNumber.trim()}
        onSecondaryClick={onPickDifferentMethod}
        isSubmitting={isSubmitting}
      />
    </Stack>
  );
};

export default PhoneEntryStep;
